








import IsLoading from "@/components/element/IsLoading.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { LoadingStatusType } from "./enums/enums";
import Layout from "./views/Layout.vue";

const StoreLogIn = namespace("LogIn");

const StoreDepartment = namespace("Department");

const StoreRevenueDeduct = namespace("RevenueDeduct");

const StoreEmployee = namespace("Employee");

@Component({
  components: {
    Layout,
    IsLoading,
  },
})
export default class App extends Vue {
  private useLayoutPage = false;
  private render = true;

  @StoreLogIn.Getter
  private getLoginLoadingStatus!: LoadingStatusType;
  destroyed() {
    localStorage.removeItem("lang");
  }

  @StoreDepartment.Mutation
  private MutationDepartmentListLoadingStatus!: (status: LoadingStatusType) => void;

  @StoreRevenueDeduct.Mutation
  private MutationRevenueDeductLoadingStatus!: (status: LoadingStatusType) => void;

  @StoreEmployee.Mutation
  private MutationEmployeeLoadingStatus!: (status: LoadingStatusType) => void;

  get isLoginSuccess(): boolean {
    return this.getLoginLoadingStatus === LoadingStatusType.Success;
  }
  @Watch("$localStorage.lang", { immediate: true })
  localStorageLangChanged(newVal: any, oldVal: any) {
    if (localStorage.lang != null) {
      this.$i18n.locale = localStorage.lang;
    }
  }

  @Watch("$route", { immediate: true })
  routeChanged(newVal: any) {
    this.setWebTitle(this.$t(newVal.meta.title));
    if (newVal.name) {
      this.setUseLayoutPage(newVal.name);
    }
  }

  @Watch("$i18n.locale")
  localeChanged(newVal: any) {
    localStorage.setItem("lang", newVal);
    this.render = false;
    this.setWebTitle(this.$t(this.$route.meta.title));
    this.$nextTick(() => {
      this.MutationDepartmentListLoadingStatus(LoadingStatusType.None);
      this.MutationRevenueDeductLoadingStatus(LoadingStatusType.None);
      this.MutationEmployeeLoadingStatus(LoadingStatusType.None);
      this.render = true;
    });
  }

  public setUseLayoutPage(routerName: string) {
    switch (routerName) {
      case "login":
      case "selectList":
      case "logout":
      case "statement":
      case "withholdingTax":
      case "pageNotFound":
      case "sessionExpire":
      case "canNotAccessMerchant":
      case "CanNotAccess":
      case "pnd1K":
      case "pnd1KItem":
      case "update":
        this.useLayoutPage = false;
        break;

      default:
        this.useLayoutPage = true;
        break;
    }
  }

  public setWebTitle(title: any) {
    if (title) {
      document.title = title;
    }
  }
}
